/** เข้าสู่ระบบ */
export default {
  label: {
    code: 'เข้าสู่ระบบด้วย SMS',
    pswd: 'เข้าสู่ระบบด้วยรหัสผ่าน'
  },
  phone: 'เบอร์โทรศัพท์',
  password: 'รหัสผ่าน',
  code: 'ยืนยัน{type}',
  sms: 'SMS',
  img: 'รูปภาพ',
  getCode: 'ส่ง',
  login: 'เข้าสู่ระบบ',
  choose: 'เลือกผู้ค้า',
  agree: 'เบอร์โทรศัพท์ที่ยังไม่ได้ลงทะเบียนจะถูกลงทะเบียนโดยอัตโนมัติ การติ๊กหมายถึงการยอมรับและตกลง',
  agreement: '《ข้อตกลงผู้ใช้แพลตฟอร์มผู้ค้า》',
  second: 'วินาที',
  wx: 'เข้าสู่ระบบด้วย WeChat',
  activity_platform: {
    title: 'แพลตฟอร์มจัดการกิจกรรม',
    subtitle: 'จากง่ายไปจนถึงซับซ้อน การเปลี่ยนแปลงและการตั้งค่าที่ไม่มีที่สิ้นสุดเพื่อตอบสนองความต้องการกิจกรรมของคุณ',
    features: [
      'จัดกิจกรรมขนาดใหญ่ผ่านหลายรอบและกลุ่มหมวดหมู่',
      'เพิ่มการเปิดเผยกิจกรรมของคุณผ่านการจัดอันดับความนิยม',
      'บรรลุการโปรโมตหลายรูปแบบผ่านการโหลดโฆษณา',
      'เลือกผู้เข้าร่วมที่ดีที่สุดอย่างแม่นยำผ่านการประเมินหลายมิติ',
      'แสดงฉากที่สดใสผ่านการอัปโหลดรูปภาพและวิดีโอ'
    ]
  },
  evaluation: {
    title: 'การประเมินและการเลื่อนระดับ',
    subtitle: 'การประเมินหลายมิติเพื่อการคัดเลือกที่ยุติธรรมและเป็นทางการที่สุด',
    features: [
      'สร้างแผนการให้คะแนนหลายมิติสำหรับกลุ่มต่างๆ การคัดเลือกแบบผสม',
      'เลือกระหว่างวิธีการประเมินแบบให้คะแนนและการตัดสิน',
      'กรรมการหลายคนประเมินและให้คะแนนพร้อมกันเพื่อความยุติธรรม',
      'การดำเนินการด้วยคลิกเดียวสำหรับการคัดกรองผู้เข้าร่วม การเลื่อนระดับและการคัดออก',
      'สร้างใบประกาศและอันดับสำหรับผู้เข้าร่วมที่โดดเด่น'
    ]
  },
  moments: {
    title: 'ช่วงเวลาสำคัญ',
    subtitle: 'บันทึกช่วงเวลาสำคัญในกิจกรรมผ่านรูปภาพและวิดีโอ',
    features: [
      'อัปโหลดรูปภาพหรือวิดีโอ เผยแพร่บนมือถือเป็นที่ระลึกของช่วงเวลาสำคัญ',
      'จัดการอย่างมีประสิทธิภาพผ่านแท็กและหมวดหมู่ของรูปภาพและวิดีโอ',
      'ดาวน์โหลดรูปภาพและวิดีโอให้ผู้ใช้เก็บช่วงเวลาสำคัญไว้ถาวร'
    ]
  },
  popularity: {
    title: 'อันดับความนิยม',
    subtitle: 'สะท้อนความนิยมของกิจกรรมอย่างสมบูรณ์ผ่านรายการอันดับ',
    features: [
      'อันดับไลค์ หนึ่งเสียงต่อคนแสดงความนิยมสูงของกิจกรรม',
      'อันดับของขวัญ มีส่วนร่วมในการสนับสนุนผู้เข้าร่วมยอดนิยม',
      'อันดับหลายขั้นตอนแสดงความนิยมที่แตกต่างกันในแต่ละขั้นตอน',
      'อันดับหลายกลุ่มแสดงผู้เข้าร่วมยอดนิยมในกลุ่มต่างๆ'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/th/login.js